import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './assets/style/index.css';
import { Provider } from 'react-redux';
import { store } from './store/store';
import AuthContext from './widgets/AuthContext';
import VoucherEntryContext from './context/VoucherEntryContext';
import StudentAddFormProvider from './context/StudentAddMultiStepContext';
import StaffAddFormProvider from './context/StaffAddStepContext';
import StudentEditFormProvider from './context/StudentEditMultiStepContext';
import { HashRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <VoucherEntryContext>
        <AuthContext>
          <StaffAddFormProvider>
            <StudentEditFormProvider>
              <StudentAddFormProvider>
                <HashRouter>
                  <App />
                </HashRouter>
              </StudentAddFormProvider>
            </StudentEditFormProvider>
          </StaffAddFormProvider>
        </AuthContext>
      </VoucherEntryContext>
    </Provider>
  </React.StrictMode>
);
